import React, { useState } from "react";
import {
  Card,
  CardBody,
  Button,
  Spinner,
} from "reactstrap";
import { useTranslation } from "context/TranslationProvider";
import helpers from "utils/helpers";
import { UncontrolledTooltip } from "reactstrap";
import RejectListingModal from "modals/RejectListingModal";

const ReviewCard = ({ listing, handleToggleAccount, type, isStatusUpdating }) => {
  const { t } = useTranslation();

  const currentStatus = helpers.normalizeOrderStatus(listing?.status);
  const isExpired = helpers.isExpired(listing) || currentStatus === "expired";
  const isPending = !isExpired && currentStatus === helpers.LISTING_TABLE_FILTERS.PENDING;

  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [activeAction, setActiveAction] = useState(null); // 'approve' or 'reject'

  if (!listing) return null;

  const handleApprove = async () => {
    setActiveAction("approve");
    try {
      await handleToggleAccount(
        listing,
        helpers.LISTING_TABLE_FILTERS.APPROVED,
        type || listing?.listingType
      );
    } finally {
      setActiveAction(null);
    }
  };

  const handleRejectPrompt = () => {
    setIsRejectModalOpen(true);
  };

  const handleRejectConfirm = async (selectedReasons) => {
    setActiveAction("reject");
    try {
      await handleToggleAccount(
        listing,
        helpers.LISTING_TABLE_FILTERS.REJECTED,
        type || listing?.listingType,
        {
          adminRemarks: selectedReasons,
        }
      );
      setIsRejectModalOpen(false);
    } finally {
      setActiveAction(null);
    }
  };

  const isApproved = currentStatus === helpers.LISTING_TABLE_FILTERS.APPROVED;
  const isDeleted = listing?.isDeleted;

  return (
    <Card className="shadow mb-3">
      <CardBody className="pt-3">
        <h5 className="heading-md mb-2">
          {t("page.listing.review.title", "Review Listing")}
        </h5>

        {!isPending && (
          <p className="text-sm text-muted mb-0">
            {isApproved
              ? t("page.listing.review.alreadyApproved", "This listing has already been approved.")
              : t("page.listing.review.locked", "Remarks are locked once the listing is reviewed or expired.")}
          </p>
        )}

        {isPending && (
          <div className="d-flex justify-content-end mt-3">
            
            <Button
              id="reject-btn"
              color="danger"
              outline
              className="mr-2"
              disabled={isDeleted || isStatusUpdating}
              onClick={handleRejectPrompt}
            >
              {isStatusUpdating && activeAction === "reject" ? (
                <Spinner size="sm" className="mr-2" />
              ) : null}
              {t("page.offerListings.status.reject", "Reject")}
            </Button>

            <RejectListingModal
              isOpen={isRejectModalOpen}
              toggle={() => setIsRejectModalOpen(false)}
              onConfirm={handleRejectConfirm}
              isDeleted={isDeleted}
              isLoading={isStatusUpdating && activeAction === "reject"}
            />

            <Button
              id="approve-btn"
              color="success"
              disabled={isDeleted || isStatusUpdating}
              onClick={handleApprove}
            >
              {isStatusUpdating && activeAction === "approve" ? (
                <Spinner size="sm" className="mr-2" />
              ) : null}
              {t("page.userListings.status.approve", "Approve")}
            </Button>

            {isDeleted && (
              <>
                <UncontrolledTooltip target="reject-btn">
                  {t("tooltip.alreadyDeleted", "Listing already deleted")}
                </UncontrolledTooltip>

                <UncontrolledTooltip target="approve-btn">
                  {t("tooltip.alreadyDeleted", "Listing already deleted")}
                </UncontrolledTooltip>
              </>
            )}
            
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default ReviewCard;
